import React, { useState } from "react";
import DeviceSidebar from "./deviceSidebar";


import Dashcam from "./Live/dashcam";
import HistoryPage from "./HistoryPage";
import EventsPage from "./Event/EventsPage";

const HEADER_HEIGHT = 90;
const ICON_RAIL_WIDTH = 80;

const DashcamLayout = () => {
  const [activeNav, setActiveNav] = useState("live");

  const renderPage = () => {
    switch (activeNav) {
      case "events":
       
        return <EventsPage />;

      case "history":
        return <HistoryPage />;;

      case "setting":
        return <Dashcam />;

      case "gallery":
        return<Dashcam />;

      default:
        return <Dashcam />;
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: HEADER_HEIGHT,
        left: ICON_RAIL_WIDTH,
        right: 0,
        bottom: 0,
        display: "flex",
      }}
    >
      <DeviceSidebar
        activeNav={activeNav}
        setActiveNav={setActiveNav}
      />

      <div
        style={{
          flex: 1,
          overflow: "hidden",
        }}
      >
        {renderPage()}
      </div>
    </div>
  );
};

export default DashcamLayout;